var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WrappedForm',{ref:"form",staticClass:"language-editor",attrs:{"labelBold":"","labelWidth":"150px","model":_vm.languageData,"formLines":_vm.formLines}})
}
var staticRenderFns = []

export { render, staticRenderFns }